import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import classNames from 'classnames'
import SinglePlanModal from './SinglePlanModal'
import ComparePlansModal from './ComparePlansModal'

import { ReactComponent as PlanIcon } from '../../../assets/svg/icons/plan-icon.svg'

import '../../../assets/sass/components/plans/plan-alert.scss'

const PlanAlert = ({
    plan = "gold",
    icon: Icon = PlanIcon,
    title = 'Gold Account',
    subtitle = 'Subscription Expiring on 12/31/2021',
    link = {
        text: 'See more Details',
        href: '#'
    },
    btn = {
        text: 'Upgrade Account',
        props: {
            size: 'md'
        }
    },
    ...props
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <div className={classNames("plan-alert", plan, props.className)}>
            <div className="info-container">
                <div className="icon-container">
                    <Icon className="icon" />
                </div>
                <div className="message-container">
                    <h4 className="title">{title}</h4>
                    <div className="inline">
                        <span className="subtitle">{subtitle}</span>
                        <Button variant="link" className="link" onClick={() => setShowModal('single')}>{link.text}</Button>
                    </div>
                </div>
            </div>
            <div className="btn-container">
                <Button variant="primary" onClick={() => setShowModal('compare')} {...btn.props}>{btn.text}</Button>
            </div>
            <SinglePlanModal
                size="md-sm"
                plan={plan}
                show={showModal === 'single'}
                onHide={() => setShowModal('')}
            />
            <ComparePlansModal
                show={showModal === 'compare'}
                onHide={() => setShowModal('')}
            />
        </div>
    )
}

export default PlanAlert
